// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideForm_edit__l6Db0 {
  width: 484px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: -100%;
  background-color: #f5f5ff;
  padding: 32px;
  transition: right 0.5s;
  overflow: scroll;
}
.SideForm_edit__l6Db0 .SideForm_close__N934S {
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
}
.SideForm_edit__l6Db0 button {
  width: 199px;
}
.SideForm_edit__l6Db0:before {
  content: "";
  background-color: #00007a;
  opacity: 0;
  width: calc(100vw - 484px);
  height: 100vh;
  display: block;
  position: fixed;
  top: 0;
  right: -100vw;
  transition: right 0s, opacity 0.5s;
}
.SideForm_edit__l6Db0.SideForm_active__M3bE0 {
  right: 0;
}
.SideForm_edit__l6Db0.SideForm_active__M3bE0:before {
  opacity: 0.5;
  right: 484px;
}

@media screen and (max-width: 600px) {
  .SideForm_edit__l6Db0 {
    width: 100vw;
  }
  .SideForm_edit__l6Db0.SideForm_active__M3bE0:before {
    right: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/components/SideForm/SideForm.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,yBCTO;EDUP,aAAA;EACA,sBAAA;EACA,gBAAA;AAIJ;AAFI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAIR;AAgCI;EACI,YAAA;AA9BR;AAiCI;EACI,WAAA;EACA,yBCrDG;EDsDH,UAAA;EACA,0BAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,kCAAA;AA/BR;AAkCI;EACI,QAAA;AAhCR;AAkCQ;EACI,YAAA;EACA,YAAA;AAhCZ;;AAuCA;EACI;IACI,YAAA;EApCN;EAsCM;IACI,YAAA;EApCV;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.edit{\n    width: 484px;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    right: -100%;\n    background-color: colors.$primary1;\n    padding: 32px;\n    transition: right 0.5s;\n    overflow: scroll;\n\n    .close{\n        position: absolute;\n        top: 24px;\n        right: 24px;\n        cursor: pointer;\n    }\n\n    // > ul{\n    //     display: flex;\n    //     gap: 20px;\n    //     flex-direction: column;\n\n    //     > li{\n    //         list-style-type: none;\n    //         background-color: #FFFFFF;\n    //         border: 1px solid colors.$primary2;\n    //         border-radius: 12px;\n    //         padding: 20px;\n    //         color: colors.$primary8;\n    //         font-size: 14px;\n    //         font-weight: 400;\n    \n    //         h2{\n    //             font-size: 20px;\n    //             font-weight: 500;\n    //         }\n    \n    //         h3{\n    //             font-size: 12px;\n    //             font-weight: 300;\n    //             margin-top: 10px;\n    //             margin-bottom: 3px;\n    //         }\n    \n    //         svg{\n    //             float: right;\n    //         }\n    //     }\n    // }\n\n    button{\n        width: 199px;\n    }\n\n    &:before{\n        content: '';\n        background-color: colors.$primary8;\n        opacity: 0;\n        width: calc(100vw - 484px);\n        height: 100vh;\n        display: block;\n        position: fixed;\n        top: 0;\n        right: -100vw;\n        transition: right 0s, opacity 0.5s;\n    }\n\n    &.active{\n        right: 0;\n\n        &:before{\n            opacity: 0.5;\n            right: 484px;\n        }\n    }\n}\n\n\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n    .edit{\n        width: 100vw;\n\n        &.active:before{\n            right: 100vw;\n        }\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"edit": `SideForm_edit__l6Db0`,
	"close": `SideForm_close__N934S`,
	"active": `SideForm_active__M3bE0`
};
export default ___CSS_LOADER_EXPORT___;
